import { createContext } from "react";
import { userStore } from "../../../stores/sharedStores";
import { ShipmentStore } from "./ShipmentStore";
import { ProductStore } from "./ProductStore";
import { PodCatalogStore } from "./PodCatalogStore";
import { ProductListingStore } from "./ProductListingStore";
import { CategoryStore } from "./CategoryStore";
import { EmployeeStore } from "./EmployeeStore";
import { TaskTrackerStore } from "./TaskTrackerStore";
import { StockStore } from "./StockStore";
import { ProjectStore } from "./ProjectStore";
import { VendorStore } from "./VendorStore";
import { ChatStore } from "./ChatStore";
import { CustomerStore } from "./CustomerStore";
import { OrderStore } from "./OrderStore";
import { InventoryStore } from "./InventoryStore";
import { CouponStore } from "./CouponStore";
import { ServiceStore } from "./ServiceStore";
import { AddressStore } from "./AddressStore";
import { InvoiceStore } from "./InvoiceStore";
import { ProjectManagementStore } from "./ProjectManagement/ProjectManagementStore";
import { ProjectSourcingOpsStore } from "./ProjectManagement/ProjectSourcingOpsStore";
import WarehouseStore from "./WarehouseStore";
import { PartnerAnalyticsDashboardStore } from "./PartnerAnalyticsDashboardStore";
import { OpsAnalyticsDashboardStore } from "./OpsAnalyticsDashboardStore";
import { ProjectInventoryOpsStore } from "./ProjectManagement/ProjectInventoryOpsStore";
import { ProjectPackagingOpsStore } from "./ProjectManagement/ProjectPackagingOpsStore";

import { OpsSourcingAnalyticsDashboardStore } from "./OpsSourcingAnalyticsDashboardStore";
import { VendorsAnalyticsStore } from "./VendorsAnalyticsStore";
import { SalesAnalyticsDashboardStore } from "./SalesAnalyticsDashboardStore";
import { FinanceAnalyticsStore } from "./FinanceAnalyticsStore";
import { QCAnalyticsDashboardStore } from "./QCAnalyticsDashboardStore";
import { MockupsAnalyticsDashboardStore } from "./MockupsAnalyticsDashboard";
import { UrgentSourcingAnalyticsDashboardStore } from "./dashboards/UrgentSourcingAnalyticsStore";
import { StockCheckAnalyticsDashboardStore } from "./dashboards/StockCheckAnalyticsStore";
import { LogisticsAnalyticsDashboardStore } from "./dashboards/LogisticsAnalyticsStore";
import { NPSAnalyticsDashboardStore } from "./dashboards/NPSAnalyticsStore";
import { CustomerExperienceAnalyticsDashboardStore } from "./dashboards/CustomerExperienceAnalyticsStore";
import { OnelinkRequestStore } from "./OnelinkRequestStore";
import { UnpaidSamplesAnalyticsDashboardStore } from "./dashboards/UnpaidSamplesAnalyticsStore";
import { PurchaseRequestStore } from "./PurchaseRequestStore";
import { UrgentSourcingStore } from "./UrgentSourcingStore";
import { OpsSyncAnalyticsDashboardStore } from "./dashboards/OpsSyncAnalyticsStore";
import { JobsStore } from "./JobsStore";
import { SwagStoreStore } from "./SwagStoreStore";
import { SwageazyInventoryStore } from "./SwageazyInventoryStore";
import { DashboardAnalyticsStore } from "./dashboards/DashboardAnalyticsStore";
import { PropertyStore } from "./PropertyStore";
import { VendorPaymentsStore } from "./VendorPaymentsStore";
import { CampaignStore } from "./CampaignStore";
import { MockupConfigStore } from "./MockupConfigStore";
import { HrmsStore } from "./HrmsStore";
import { StorageCostStore } from "./StorageCostStore";
import { LeadAnalyticsStore } from "./LeadAnalyticsStore";
import { PodOrderStore } from "./PodOrderStore";

export const rootStoreContext = createContext({
  userStore,
  shipmentStore: new ShipmentStore(),
  productStore: new ProductStore(),
  podCatalogStore: new PodCatalogStore(),
  productListingStore: new ProductListingStore(),
  categoryStore: new CategoryStore(),
  employeeStore: new EmployeeStore(),
  TaskTrackerStore: new TaskTrackerStore(),
  stockStore: new StockStore(),
  projectStore: new ProjectStore(),
  vendorStore: new VendorStore(),
  chatStore: new ChatStore(),
  customerStore: new CustomerStore(),
  orderStore: new OrderStore(),
  inventoryStore: new InventoryStore(),
  couponStore: new CouponStore(),
  addressStore: new AddressStore(),
  invoiceStore: new InvoiceStore(),
  serviceStore: new ServiceStore(),
  projectManagementStore: new ProjectManagementStore(),
  partnerAnalyticsDashboardStore: new PartnerAnalyticsDashboardStore(),
  opsAnalyticsDashboardStore: new OpsAnalyticsDashboardStore(),
  opsSourcingAnalyticsDashboardStore: new OpsSourcingAnalyticsDashboardStore(),
  projectSourcingOpsStore: new ProjectSourcingOpsStore(),
  projectInventoryOpsStore: new ProjectInventoryOpsStore(),
  warehouseStore: new WarehouseStore(),
  projectPackagingOpsStore: new ProjectPackagingOpsStore(),
  vendorsAnalyticsDashboardStore: new VendorsAnalyticsStore(),
  salesAnalyticsDashboardStore: new SalesAnalyticsDashboardStore(),
  financeAnalyticsStore: new FinanceAnalyticsStore(),
  qcAnalyticsDashboardStore: new QCAnalyticsDashboardStore(),
  mockupsAnalyticsDashboardStore: new MockupsAnalyticsDashboardStore(),
  urgentSourcingAnalyticsDashboardStore:
    new UrgentSourcingAnalyticsDashboardStore(),
  stockCheckAnalyticsDashboardStore: new StockCheckAnalyticsDashboardStore(),
  logisticsAnalyticsDashboardStore: new LogisticsAnalyticsDashboardStore(),
  npsAnalyticsDashboardStore: new NPSAnalyticsDashboardStore(),
  customerExperienceAnalyticsDashboardStore:
    new CustomerExperienceAnalyticsDashboardStore(),
  onelinkRequestStore: new OnelinkRequestStore(),
  purchaseRequestStore: new PurchaseRequestStore(),
  urgentSourcingStore: new UrgentSourcingStore(),
  unpaidSamplesAnalyticsDashboardStore:
    new UnpaidSamplesAnalyticsDashboardStore(),
  opsSyncAnalyticsDashboardStore: new OpsSyncAnalyticsDashboardStore(),
  jobsStore: new JobsStore(),
  swagStoreStore: new SwagStoreStore(),
  swageazyInventoryStore: new SwageazyInventoryStore(),
  dashboardAnalyticsStore: new DashboardAnalyticsStore(),
  propertyStore: new PropertyStore(),
  campaignStore: new CampaignStore(),
  vendorPaymentsStore: new VendorPaymentsStore(),
  hrmsStore: new HrmsStore(),
  mockupConfigStore: new MockupConfigStore(),
  storageCostStore: new StorageCostStore(),
  leadAnalyticsStore: new LeadAnalyticsStore(),
  podOrderStore: new PodOrderStore(),
});

export default function reset() { }
